(function () {
  window.SPCLST = window.SPCLST || {};
  window.SPCLST.modules = window.SPCLST.modules || {};

  window.SPCLST.modules.product = function (helpers) {
    var query = helpers.query;
    var queryAll = helpers.queryAll;

    var productForms = document.querySelectorAll('[data-spclst-product-form]');
    productForms.forEach(function (container) {
      var variantsJson = container.querySelector('[data-spclst-variants]');
      if (!variantsJson) return;

      var variants;
      try {
        variants = JSON.parse(variantsJson.textContent || '[]');
      } catch (error) {
        variants = [];
      }
      if (!variants.length) return;

      var optionButtons = container.querySelectorAll('[data-option-index][data-option-value]');
      var variantInput = container.querySelector('input[name="id"]');
      var priceEl = container.querySelector('[data-spclst-price]');
      var comparePriceEl = container.querySelector('[data-spclst-price-compare]');
      var currentPriceEl = container.querySelector('[data-spclst-price-current]');
      var finalSaleEl = container.querySelector('[data-spclst-auto-final-sale]');
      var addButton = container.querySelector('[data-spclst-add]');
      var addButtonLabel = container.querySelector('.pdpdraftcartbuttontext');
      var colorGroup = container.querySelector('[data-spclst-color-option-index]');
      var colorLabel = container.querySelector('[data-spclst-color-label]');
      var galleryInstances = [];
      var colorOptionIndex = colorGroup ? parseInt(colorGroup.getAttribute('data-spclst-color-option-index') || '-1', 10) : -1;

      function setVariantInputValue(value) {
        if (!variantInput) return;
        var nextValue = value == null ? '' : String(value);
        variantInput.value = nextValue;
        variantInput.setAttribute('value', nextValue);
      }

      function initPdpGallery(galleryRoot) {
        if (!galleryRoot) return null;
        if (galleryRoot.getAttribute('data-spclst-initialized') === 'true') return null;
        galleryRoot.setAttribute('data-spclst-initialized', 'true');

        var slides = queryAll('[data-spclst-pdp-media-slide]', galleryRoot);
        if (!slides.length) return null;

        var dots = queryAll('[data-spclst-pdp-media-dot]', galleryRoot);
        var prevButton = query('[data-spclst-pdp-media-prev]', galleryRoot);
        var nextButton = query('[data-spclst-pdp-media-next]', galleryRoot);
        var videoTrigger = query('[data-spclst-video-open]', galleryRoot);
        var videoModal = query('[data-spclst-video-modal]', galleryRoot);
        var currentIndex = 0;
        var touchStartX = 0;
        var touchStartY = 0;
        var previousActiveElement = null;
        var slideTransitionTimer = null;
        var slideAnimationFrame = null;

        slides.forEach(function (slide, index) {
          if (slide.classList.contains('is-active')) currentIndex = index;
        });

        function extractYouTubeId(url) {
          if (!url) return '';

          var normalizedUrl = String(url).trim();
          var shortMatch = normalizedUrl.match(/youtu\.be\/([^?&#/]+)/i);
          if (shortMatch && shortMatch[1]) return shortMatch[1];

          var embedMatch = normalizedUrl.match(/youtube\.com\/embed\/([^?&#/]+)/i);
          if (embedMatch && embedMatch[1]) return embedMatch[1];

          var shortsMatch = normalizedUrl.match(/youtube\.com\/shorts\/([^?&#/]+)/i);
          if (shortsMatch && shortsMatch[1]) return shortsMatch[1];

          var watchMatch = normalizedUrl.match(/[?&]v=([^?&#/]+)/i);
          if (watchMatch && watchMatch[1]) return watchMatch[1];

          return '';
        }

        function buildVideoEmbedUrl(url) {
          if (!url) return '';
          var youtubeId = extractYouTubeId(url);
          if (youtubeId) {
            return 'https://www.youtube-nocookie.com/embed/' + youtubeId + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
          }
          return url;
        }

        function clearSlideTransitionState() {
          if (slideTransitionTimer) {
            window.clearTimeout(slideTransitionTimer);
            slideTransitionTimer = null;
          }

          if (slideAnimationFrame) {
            window.cancelAnimationFrame(slideAnimationFrame);
            slideAnimationFrame = null;
          }

          slides.forEach(function (slide) {
            slide.classList.remove('is-entering-from-right');
            slide.classList.remove('is-entering-from-left');
            slide.classList.remove('is-leaving-to-left');
            slide.classList.remove('is-leaving-to-right');
          });
        }

        function getStepDirection(fromIndex, toIndex) {
          if (fromIndex === toIndex) return 0;

          var total = slides.length;
          var forwardDistance = (toIndex - fromIndex + total) % total;
          var backwardDistance = (fromIndex - toIndex + total) % total;

          return forwardDistance <= backwardDistance ? 1 : -1;
        }

        // Keep the current photo and its neighbors ready without fetching every color.
        function prepareGalleryImage(index) {
          var slide = slides[(index + slides.length) % slides.length];
          if (!slide) return;
          queryAll('img[data-spclst-src]', slide).forEach(function (image) {
            var srcset = image.getAttribute('data-spclst-srcset');
            if (srcset) image.setAttribute('srcset', srcset);
            image.setAttribute('src', image.getAttribute('data-spclst-src'));
            image.removeAttribute('data-spclst-srcset');
            image.removeAttribute('data-spclst-src');
          });
        }

        function setActive(index, direction) {
          if (!slides.length) return;
          var total = slides.length;
          var previousIndex = currentIndex;
          var nextIndex = ((index % total) + total) % total;
          prepareGalleryImage(nextIndex);
          prepareGalleryImage(nextIndex - 1);
          prepareGalleryImage(nextIndex + 1);
          var transitionDirection = typeof direction === 'number' && direction !== 0
            ? direction
            : getStepDirection(previousIndex, nextIndex);

          if (nextIndex === previousIndex) {
            clearSlideTransitionState();
            slides.forEach(function (slide, slideIndex) {
              var active = slideIndex === nextIndex;
              slide.classList.toggle('is-active', active);
              slide.setAttribute('aria-hidden', active ? 'false' : 'true');
            });

            dots.forEach(function (dot, dotIndex) {
              var isActive = dotIndex === nextIndex;
              dot.classList.toggle('is-active', isActive);
              dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });

            return;
          }

          clearSlideTransitionState();
          currentIndex = nextIndex;

          var previousSlide = slides[previousIndex];
          var nextSlide = slides[nextIndex];
          var enteringClass = transitionDirection > 0 ? 'is-entering-from-right' : 'is-entering-from-left';
          var leavingClass = transitionDirection > 0 ? 'is-leaving-to-left' : 'is-leaving-to-right';

          if (previousSlide) {
            previousSlide.classList.add(leavingClass);
            previousSlide.setAttribute('aria-hidden', 'true');
          }

          if (nextSlide) {
            nextSlide.classList.add(enteringClass);
            nextSlide.setAttribute('aria-hidden', 'false');
          }

          slides.forEach(function (slide, slideIndex) {
            if (slideIndex !== previousIndex && slideIndex !== nextIndex) {
              slide.classList.remove('is-active');
              slide.setAttribute('aria-hidden', 'true');
            }
          });

          dots.forEach(function (dot, dotIndex) {
            var isActive = dotIndex === currentIndex;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          slideAnimationFrame = window.requestAnimationFrame(function () {
            slideAnimationFrame = null;

            if (nextSlide) {
              nextSlide.classList.add('is-active');
              nextSlide.classList.remove(enteringClass);
            }

            if (previousSlide) {
              previousSlide.classList.remove('is-active');
            }

            slideTransitionTimer = window.setTimeout(function () {
              clearSlideTransitionState();
              slides.forEach(function (slide, slideIndex) {
                var active = slideIndex === currentIndex;
                slide.classList.toggle('is-active', active);
                slide.setAttribute('aria-hidden', active ? 'false' : 'true');
              });
            }, 420);
          });
        }

        function findSlideIndexByMediaId(mediaId) {
          if (!mediaId) return -1;
          var targetId = String(mediaId);
          var matchIndex = -1;
          slides.some(function (slide, index) {
            if (String(slide.getAttribute('data-media-id')) === targetId) {
              matchIndex = index;
              return true;
            }
            return false;
          });
          return matchIndex;
        }

        if (prevButton) {
          prevButton.addEventListener('click', function () {
            setActive(currentIndex - 1, -1);
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', function () {
            setActive(currentIndex + 1, 1);
          });
        }

        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            var dotIndex = parseInt(dot.getAttribute('data-spclst-pdp-media-dot-index') || '0', 10);
            if (isNaN(dotIndex)) return;
            setActive(dotIndex);
          });
        });

        galleryRoot.addEventListener(
          'touchstart',
          function (event) {
            if (!event.touches || !event.touches.length) return;
            touchStartX = event.touches[0].clientX;
            touchStartY = event.touches[0].clientY;
          },
          { passive: true }
        );

        galleryRoot.addEventListener(
          'touchend',
          function (event) {
            if (!event.changedTouches || !event.changedTouches.length) return;
            var touchEndX = event.changedTouches[0].clientX;
            var touchEndY = event.changedTouches[0].clientY;
            var deltaX = touchEndX - touchStartX;
            var deltaY = touchEndY - touchStartY;
            var horizontalSwipe = Math.abs(deltaX) > 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2;

            if (!horizontalSwipe) return;
            if (deltaX < 0) {
              setActive(currentIndex + 1, 1);
            } else {
              setActive(currentIndex - 1, -1);
            }
          },
          { passive: true }
        );

        if (videoTrigger && videoModal) {
          if (videoModal.parentNode !== document.body) {
            document.body.appendChild(videoModal);
          }

          var videoFrame = query('[data-spclst-video-iframe]', videoModal);
          var videoCloseButtons = queryAll('[data-spclst-video-close]', videoModal);
          var videoSourceUrl = videoTrigger.getAttribute('data-spclst-video-url') || '';

          function closeVideoModal() {
            if (!videoModal || videoModal.hidden) return;
            videoModal.hidden = true;
            videoModal.setAttribute('aria-hidden', 'true');
            videoModal.classList.remove('is-open');
            document.body.classList.remove('spclst-video-modal-open');
            if (videoFrame) videoFrame.src = '';
            if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
              previousActiveElement.focus();
            }
          }

          function openVideoModal() {
            if (!videoFrame || !videoSourceUrl) return;
            previousActiveElement = document.activeElement;
            videoFrame.src = buildVideoEmbedUrl(videoSourceUrl);
            videoModal.hidden = false;
            videoModal.setAttribute('aria-hidden', 'false');
            videoModal.classList.add('is-open');
            document.body.classList.add('spclst-video-modal-open');
          }

          videoTrigger.addEventListener('click', function (event) {
            event.preventDefault();
            openVideoModal();
          });

          videoCloseButtons.forEach(function (button) {
            button.addEventListener('click', function (event) {
              event.preventDefault();
              closeVideoModal();
            });
          });

          document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') closeVideoModal();
          });
        }

        setActive(currentIndex);

        return {
          setByMediaId: function (mediaId) {
            var index = findSlideIndexByMediaId(mediaId);
            if (index >= 0) setActive(index);
          },
        };
      }

      queryAll('[data-spclst-pdp-gallery]', container).forEach(function (galleryRoot) {
        var instance = initPdpGallery(galleryRoot);
        if (instance) galleryInstances.push(instance);
      });

      var featureTriggers = queryAll('[data-spclst-feature-toggle]', container);

      function setFeatureExpanded(trigger, expanded) {
        var item = trigger.closest('.spclst-pdp-feature-item');
        var body = item ? query('[data-spclst-feature-body]', item) : null;
        var icon = item ? query('[data-spclst-feature-icon]', item) : null;
        if (!body) return;

        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        body.hidden = !expanded;
        if (icon) icon.textContent = expanded ? '-' : '+';
        if (item) item.classList.toggle('is-open', expanded);
      }

      featureTriggers.forEach(function (trigger) {
        var item = trigger.closest('.spclst-pdp-feature-item');
        if (!item || !query('[data-spclst-feature-body]', item)) return;

        trigger.addEventListener('click', function () {
          var shouldExpand = trigger.getAttribute('aria-expanded') !== 'true';

          if (shouldExpand) {
            featureTriggers.forEach(function (otherTrigger) {
              if (otherTrigger !== trigger) setFeatureExpanded(otherTrigger, false);
            });
          }

          setFeatureExpanded(trigger, shouldExpand);
        });
      });

      function updateOptionVisualState(btn, isActive) {
        var kind = btn.getAttribute('data-option-kind');
        if (!kind) return;

        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        if (kind === 'size' || kind === 'generic') {
          if (isActive) {
            btn.classList.remove('pdpdraftproductsizeselector');
            btn.classList.add('pdpdraftproductsizeselected');
          } else {
            btn.classList.remove('pdpdraftproductsizeselected');
            btn.classList.add('pdpdraftproductsizeselector');
          }
        }

        if (kind === 'color') {
          btn.classList.toggle('spclst-color-choice--active', isActive);
        }
      }

      function getSelectedOptions() {
        var selected = {};
        container.querySelectorAll('[data-option-index].is-active').forEach(function (btn) {
          selected[btn.getAttribute('data-option-index')] = btn.getAttribute('data-option-value');
        });
        return selected;
      }

      function selectionMatchesVariant(variant, selectedOptions) {
        return variant.options.every(function (opt, idx) {
          var key = String(idx);
          return !selectedOptions[key] || selectedOptions[key] === opt;
        });
      }

      function findVariant(selectedOptions) {
        return (
          variants.find(function (variant) {
            return selectionMatchesVariant(variant, selectedOptions);
          }) || null
        );
      }

      function findBestAvailableVariant(selectedOptions) {
        return (
          variants.find(function (variant) {
            return variant.available && selectionMatchesVariant(variant, selectedOptions);
          }) ||
          variants.find(function (variant) {
            return selectionMatchesVariant(variant, selectedOptions);
          }) ||
          variants[0] ||
          null
        );
      }

      function selectionIsComplete(selectedOptions) {
        var optionCount = variants[0] && Array.isArray(variants[0].options) ? variants[0].options.length : 0;
        if (!optionCount) return false;

        for (var optionIndex = 0; optionIndex < optionCount; optionIndex += 1) {
          if (!selectedOptions[String(optionIndex)]) return false;
        }

        return true;
      }

      function clearActiveSizeSelection() {
        optionButtons.forEach(function (btn) {
          if (btn.getAttribute('data-option-kind') !== 'size' || !btn.classList.contains('is-active')) return;
          btn.classList.remove('is-active');
          updateOptionVisualState(btn, false);
        });
      }

      function setSelectedOptionsFromVariant(variant) {
        if (!variant) return;
        optionButtons.forEach(function (btn) {
          var optionIndex = parseInt(btn.getAttribute('data-option-index') || '0', 10);
          var targetValue = variant.options[optionIndex];
          var active = targetValue === btn.getAttribute('data-option-value');
          btn.classList.toggle('is-active', active);
          updateOptionVisualState(btn, active);
        });
      }

      function syncOptionAvailability() {
        var selected = getSelectedOptions();

        optionButtons.forEach(function (btn) {
          var optionIndex = btn.getAttribute('data-option-index');
          var optionKind = btn.getAttribute('data-option-kind');
          var testSelection = optionKind === 'color' ? {} : Object.assign({}, selected);
          testSelection[optionIndex] = btn.getAttribute('data-option-value');

          var available = variants.some(function (variant) {
            return variant.available && selectionMatchesVariant(variant, testSelection);
          });

          // Sold-out colors stay selectable so customers can view their media and
          // the normal out-of-stock state. Sizes still use native disabled behavior.
          btn.disabled = optionKind !== 'color' && !available;
          btn.classList.toggle('is-unavailable', !available);
          btn.setAttribute('aria-disabled', btn.disabled ? 'true' : 'false');
          if (optionKind === 'color') {
            var optionValue = btn.getAttribute('data-option-value') || '';
            btn.setAttribute('aria-label', optionValue + (available ? '' : ', sold out'));
          }
        });
      }

      function formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents);
        }
        var value = (Number(cents || 0) / 100).toFixed(2);
        return '$' + value;
      }

      function syncPrice(variant) {
        if (!variant) return;

        var price = Number(variant.price || 0);
        var compareAtPrice = Number(variant.compare_at_price || 0);
        var onSale = compareAtPrice > price;

        if (priceEl) {
          priceEl.classList.toggle('is-on-sale', onSale);
        }

        if (currentPriceEl) {
          currentPriceEl.textContent = formatMoney(price);
        } else if (priceEl) {
          priceEl.textContent = formatMoney(price);
        }

        if (comparePriceEl) {
          comparePriceEl.hidden = !onSale;
          if (onSale) {
            comparePriceEl.textContent = formatMoney(compareAtPrice);
          }
        }

        if (finalSaleEl) {
          finalSaleEl.hidden = !onSale;
        }
      }

      function syncColorLabel(variant) {
        if (!colorLabel) return;

        if (variant && variant.available === false) {
          colorLabel.textContent = 'SOLD OUT';
          return;
        }

        var defaultLabel = colorLabel.getAttribute('data-spclst-color-default-label') || '';
        var initialColorValue = colorLabel.getAttribute('data-spclst-color-initial-value') || '';
        var displayInitialColor = colorLabel.getAttribute('data-spclst-color-display-initial') === 'true';
        var nextLabel = '';

        if (variant && colorOptionIndex >= 0 && Array.isArray(variant.options)) {
          nextLabel = variant.options[colorOptionIndex] || '';
        }

        if (!nextLabel) {
          var activeColor = container.querySelector('[data-option-kind="color"].is-active');
          nextLabel = activeColor ? activeColor.getAttribute('data-option-value') || '' : '';
        }

        if (!displayInitialColor) {
          colorLabel.textContent = nextLabel || defaultLabel;
          return;
        }

        colorLabel.textContent = !nextLabel || nextLabel === initialColorValue ? defaultLabel : nextLabel;
      }

      function syncVariantMedia(variant) {
        if (!variant) return;

        var variantMediaId = null;
        if (variant.featured_media && variant.featured_media.id) {
          variantMediaId = variant.featured_media.id;
        } else if (variant.featured_image && variant.featured_image.id) {
          variantMediaId = variant.featured_image.id;
        }

        if (!variantMediaId) return;

        galleryInstances.forEach(function (gallery) {
          gallery.setByMediaId(variantMediaId);
        });
      }

      function syncPartialSelection() {
        var selected = getSelectedOptions();
        var representativeVariant = findBestAvailableVariant(selected);
        var hasAvailableMatch = variants.some(function (variant) {
          return variant.available && selectionMatchesVariant(variant, selected);
        });

        if (representativeVariant) {
          syncPrice(representativeVariant);
          syncVariantMedia(representativeVariant);
        }
        syncColorLabel(representativeVariant);

        setVariantInputValue('');
        if (addButton) {
          addButton.disabled = true;
          if (addButtonLabel) {
            addButtonLabel.textContent = hasAvailableMatch ? 'SELECT SIZE' : 'OUT OF STOCK';
          } else {
            addButton.textContent = hasAvailableMatch ? 'SELECT SIZE' : 'OUT OF STOCK';
          }
        }

        syncOptionAvailability();
      }

      function syncVariant(explicitVariant) {
        var selected = getSelectedOptions();
        var variant = explicitVariant || findBestAvailableVariant(selected);
        if (!variant) return;

        setSelectedOptionsFromVariant(variant);
        syncPrice(variant);
        syncColorLabel(variant);

        setVariantInputValue(variant.id);
        if (addButton) {
          addButton.disabled = !variant.available;
          var labelText = variant.available ? 'ADD TO CART' : 'OUT OF STOCK';
          if (addButtonLabel) {
            addButtonLabel.textContent = labelText;
          } else {
            addButton.textContent = labelText;
          }
        }

        syncVariantMedia(variant);

        syncOptionAvailability();
      }

      optionButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var optionIndex = btn.getAttribute('data-option-index');
          var optionKind = btn.getAttribute('data-option-kind');

          if (optionKind === 'color') {
            var nextSelection = getSelectedOptions();
            nextSelection[optionIndex] = btn.getAttribute('data-option-value');
            var nextVariant = findVariant(nextSelection);

            if (!nextVariant || !nextVariant.available) {
              clearActiveSizeSelection();
            }
          }

          var groupSelector = '[data-option-index="' + optionIndex + '"]';
          container.querySelectorAll(groupSelector).forEach(function (peer) {
            peer.classList.remove('is-active');
            updateOptionVisualState(peer, false);
          });
          btn.classList.add('is-active');
          updateOptionVisualState(btn, true);

          var selected = getSelectedOptions();
          if (selectionIsComplete(selected)) {
            syncVariant(findVariant(selected));
          } else {
            syncPartialSelection();
          }
        });
      });

      syncVariant();
    });

    queryAll('[data-spclst-size-guide-modal]').forEach(function (modal) {
      if (modal.getAttribute('data-spclst-initialized') === 'true') return;
      modal.setAttribute('data-spclst-initialized', 'true');

      var modalId = modal.getAttribute('id');
      var dialog = query('.spclst-size-guide-modal__dialog', modal);
      var openButtons = modalId ? queryAll('[data-spclst-size-guide-open][aria-controls="' + modalId + '"]') : [];
      var closeButtons = queryAll('[data-spclst-size-guide-close]', modal);
      var previousActiveElement = null;

      function openModal(trigger) {
        previousActiveElement = trigger || document.activeElement;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('spclst-size-guide-is-open');

        if (dialog) {
          window.setTimeout(function () {
            dialog.focus({ preventScroll: true });
          }, 0);
        }
      }

      function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('spclst-size-guide-is-open');

        if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
          previousActiveElement.focus({ preventScroll: true });
        }
      }

      openButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          openModal(button);
        });
      });

      closeButtons.forEach(function (button) {
        button.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });
    });

    // PDP callout slider (desktop)
    queryAll('[data-spclst-pdp-callouts]').forEach(function (calloutRoot) {
      if (calloutRoot.getAttribute('data-spclst-initialized') === 'true') return;
      calloutRoot.setAttribute('data-spclst-initialized', 'true');

      var viewport = query('[data-spclst-pdp-callouts-viewport]', calloutRoot);
      var track = query('[data-spclst-pdp-callouts-track]', calloutRoot);
      var slides = queryAll('[data-spclst-pdp-callout-slide]', calloutRoot);
      var dots = queryAll('[data-spclst-pdp-callout-dot]', calloutRoot);

      if (!viewport || !track || !slides.length || !dots.length) return;

      var currentIndex = 0;
      var step = 0;
      var maxScrollLeft = 0;
      var snapTimer = null;
      var ticking = false;

      function clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
      }

      function getGapValue() {
        var computed = window.getComputedStyle(track);
        var gap = parseFloat(computed.columnGap || computed.gap || '0');
        return isNaN(gap) ? 0 : gap;
      }

      function updateMetrics() {
        var firstSlide = slides[0];
        if (!firstSlide) return;

        step = firstSlide.getBoundingClientRect().width + getGapValue();
        maxScrollLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      }

      function syncDots() {
        dots.forEach(function (dot) {
          var dotIndex = parseInt(dot.getAttribute('data-spclst-pdp-callout-dot-index') || '0', 10);
          dot.classList.toggle('is-active', dotIndex === currentIndex);
        });
      }

      function setCurrentIndexFromScroll() {
        if (step <= 0) return;
        var resolved = Math.round((viewport.scrollLeft || 0) / step);
        currentIndex = clamp(resolved, 0, Math.max(0, slides.length - 1));
        syncDots();
      }

      function scrollToIndex(index, behavior) {
        updateMetrics();
        currentIndex = clamp(index, 0, Math.max(0, slides.length - 1));
        var targetLeft = clamp(currentIndex * step, 0, maxScrollLeft);
        viewport.scrollTo({ left: targetLeft, behavior: behavior || 'smooth' });
        syncDots();
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var dotIndex = parseInt(dot.getAttribute('data-spclst-pdp-callout-dot-index') || '0', 10);
          if (isNaN(dotIndex)) return;
          scrollToIndex(dotIndex, 'smooth');
        });
      });

      viewport.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            setCurrentIndexFromScroll();
            ticking = false;
          });

          if (snapTimer) window.clearTimeout(snapTimer);
          snapTimer = window.setTimeout(function () {
            scrollToIndex(currentIndex, 'smooth');
          }, 120);
        },
        { passive: true }
      );

      window.addEventListener('resize', function () {
        updateMetrics();
        scrollToIndex(currentIndex, 'auto');
      });

      updateMetrics();
      scrollToIndex(0, 'auto');
    });

    // PDP callout slider (mobile)
    queryAll('[data-spclst-pdp-callouts-mobile]').forEach(function (calloutRoot) {
      if (calloutRoot.getAttribute('data-spclst-initialized') === 'true') return;
      calloutRoot.setAttribute('data-spclst-initialized', 'true');

      var viewport = query('[data-spclst-pdp-callouts-mobile-viewport]', calloutRoot);
      var track = query('[data-spclst-pdp-callouts-mobile-track]', calloutRoot);
      var slides = queryAll('[data-spclst-pdp-callout-mobile-slide]', calloutRoot);
      var dots = queryAll('[data-spclst-pdp-callouts-mobile-dot]', calloutRoot);

      if (!viewport || !track || !slides.length) return;

      var currentIndex = 0;
      var step = 0;
      var maxScrollLeft = 0;
      var snapTimer = null;
      var ticking = false;

      function clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
      }

      function getGapValue() {
        var computed = window.getComputedStyle(track);
        var gap = parseFloat(computed.columnGap || computed.gap || '0');
        return isNaN(gap) ? 0 : gap;
      }

      function updateMetrics() {
        var firstSlide = slides[0];
        if (!firstSlide) return;

        step = firstSlide.getBoundingClientRect().width + getGapValue();
        maxScrollLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      }

      function syncPagination() {
        if (!dots.length) return;
        dots.forEach(function (dot) {
          var dotIndex = parseInt(dot.getAttribute('data-spclst-pdp-callouts-mobile-dot-index') || '-1', 10);
          dot.classList.toggle('is-active', dotIndex === currentIndex);
        });
      }

      function setCurrentIndexFromScroll() {
        if (step <= 0) return;
        var resolved = Math.round((viewport.scrollLeft || 0) / step);
        currentIndex = clamp(resolved, 0, Math.max(0, slides.length - 1));
      }

      function scrollToIndex(index, behavior) {
        updateMetrics();
        currentIndex = clamp(index, 0, Math.max(0, slides.length - 1));
        var targetLeft = clamp(currentIndex * step, 0, maxScrollLeft);
        syncPagination();
        viewport.scrollTo({ left: targetLeft, behavior: behavior || 'smooth' });
      }

      viewport.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;

          window.requestAnimationFrame(function () {
            setCurrentIndexFromScroll();
            syncPagination();
            ticking = false;
          });

          if (snapTimer) window.clearTimeout(snapTimer);
          snapTimer = window.setTimeout(function () {
            scrollToIndex(currentIndex, 'smooth');
          }, 120);
        },
        { passive: true }
      );

      window.addEventListener('resize', function () {
        updateMetrics();
        scrollToIndex(currentIndex, 'auto');
      });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var targetIndex = parseInt(dot.getAttribute('data-spclst-pdp-callouts-mobile-dot-index') || '0', 10);
          if (isNaN(targetIndex)) return;
          scrollToIndex(targetIndex, 'smooth');
        });
      });

      updateMetrics();
      syncPagination();
      scrollToIndex(0, 'auto');
    });
  };
})();
